import classNames from 'classnames';
import { ChangeEvent, FC } from 'react';

import './style.scss';

export type SelectInputLabelledProps = {
  id: string;
  label: string;
  options: ReadonlyArray<{ value: string; label: string }>;
  value: Nullable<string>;
  onValueChanged: (value: string) => void;
  isDisabled?: boolean;
  isInvalid?: boolean;
  isHighlighted?: boolean;
  isReadOnly?: boolean;
  className?: string;
};

export const SelectInputLabelled: FC<SelectInputLabelledProps> = ({
  id,
  label,
  options,
  value,
  onValueChanged,
  isInvalid = false,
  isHighlighted = false,
  isReadOnly = false,
  isDisabled = false,
  className,
}) => {
  const onChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const newValue = e.target.value;
    if (newValue !== value) {
      onValueChanged(newValue);
    }
  };

  return (
    <div
      className={`select-input-labelled-container input-group bg-lvl1 ${isHighlighted ? 'border-bottom border-info' : ''}`}
    >
      <div className="input-icon-start w-auto px-12px">
        <label htmlFor={id} className="text-secondary fs-5">
          {label}
        </label>
      </div>
      <select
        id={id}
        value={value || ''}
        onChange={onChange}
        disabled={isDisabled}
        className={classNames(
          'input form-select form-select-lg fw-medium text-end',
          { 'is-warning': isInvalid, readonly: isReadOnly },
          className,
        )}
        data-e2e={`${id}-select`}
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};
